import { themes } from "@seneca/senekit";

type GetThemeArgs = {
  isPlurallApp: boolean;
  isOnParentPlatform: boolean;
  userHasSubscription: boolean;
  isDarkMode: boolean;
};

export function getTheme({
  isPlurallApp,
  isOnParentPlatform,
  userHasSubscription,
  isDarkMode
}: GetThemeArgs) {
  const themeSet = isPlurallApp
    ? themes.plurall
    : isOnParentPlatform
    ? themes.free
    : userHasSubscription
    ? themes.premium
    : themes.free;

  if (isDarkMode) {
    return themeSet.dark;
  }

  return themeSet.light;
}
